import { defineRecipe } from "@chakra-ui/react";

export const buttonRecipe = defineRecipe({
  base: {
    textStyle: "Label/Medium",
    borderRadius: "2px",
    display: "inline-flex",
    appearance: "none",
    alignItems: "center",
    justifyContent: "center",
    userSelect: "none",
    position: "relative",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    borderWidth: "1px",
    borderColor: "transparent",
    cursor: "button",
    flexShrink: "0",
    outline: "0",
    lineHeight: "1.2",
    isolation: "isolate",
    transitionProperty: "common",
    transitionDuration: "moderate",
    focusVisibleRing: "outside",
    _disabled: {
      layerStyle: "disabled",
    },
    _icon: {
      flexShrink: "0",
    },
  },

  variants: {
    size: {
      sm: {
        h: "32px",
        px: 3,
        fontSize: "sm",
        gap: 2,
        _icon: {
          width: 4,
          height: 4,
        },
      },
      md: {
        h: "40px",
        px: 4,
        fontSize: "md",
        gap: 2,
        _icon: {
          width: 5,
          height: 5,
        },
      },
      lg: {
        h: "48px",
        px: 6,
        fontSize: "lg",
        gap: 3,
        _icon: {
          width: 6,
          height: 6,
        },
      },
    },

    variant: {
      solid: {
        bg: "colorPalette.solid",
        color: "colorPalette.contrast",
        borderColor: "transparent",
        _hover: {
          bg: "colorPalette.solid/90",
        },
        _expanded: {
          bg: "colorPalette.solid/90",
        },
      },

      outline: {
        borderWidth: "1px",
        borderColor: "colorPalette.solid",
        color: "colorPalette.solid",
        bg: "transparent",
        _hover: {
          bg: "colorPalette.subtle",
        },
        _expanded: {
          bg: "colorPalette.subtle",
        },
      },

      ghost: {
        bg: "transparent",
        color: "colorPalette.solid",
        _hover: {
          bg: "colorPalette.subtle",
        },
        _expanded: {
          bg: "colorPalette.subtle",
        },
      },

      link: {
        bg: "transparent",
        color: "colorPalette.solid",
        padding: "0",
        height: "auto",
        lineHeight: "inherit",
        textDecoration: "underline",
        textUnderlineOffset: "2px",
        _hover: {
          bg: "transparent",
        },
        _expanded: {
          bg: "transparent",
        },
      },
    },
  },

  defaultVariants: {
    size: "md",
    variant: "solid",
  },
});
